
import React from "react";

interface SummaryBoxProps {
  icon?: React.ReactNode;
  label: string;
  value: React.ReactNode;
  className?: string;
  // Optional: show if the value is editable
  editable?: boolean;
  onClickEdit?: () => void;
}

const SummaryBox = ({
  icon,
  label,
  value,
  className = "",
  editable = false,
  onClickEdit,
}: SummaryBoxProps) => (
  <div className={`relative z-10 ${className}`}>
    <div
      className={`p-4 bg-autocare-blue/10 rounded-xl transition-shadow ${
        editable
          ? "cursor-pointer border border-autocare-blue/30 hover:border-autocare-blue focus-within:border-autocare-blue shadow-md"
          : ""
      }`}
      onClick={editable ? onClickEdit : undefined}
      tabIndex={editable ? 0 : -1}
      role={editable ? "button" : undefined}
      aria-label={editable ? `Change ${label}` : undefined}
    >
      <div className="flex items-center">
        {icon && <div className="mr-4">{icon}</div>}
        <div>
          <div className="text-sm text-gray-600">{label}</div>
          <div className={`font-semibold ${editable ? "text-autocare-blue" : ""}`}>
            {value}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SummaryBox;
